const errorTranslations = {
  "errors.failedToSendInformation": "ინფორმაციის გაგზავნა ვერ მოხერხდა",
};

export default errorTranslations;
